import React from "react";
import {
  Box,
  Grid,
  Typography,
  Container,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import aboutusImage from "@assets/images/1.png";

// Styled Components
const PageSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(10, 0),
  position: "relative",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  position: "relative",
  fontWeight: 700,
  paddingBottom: theme.spacing(2),
  display: "inline-block",
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "80px",
    height: "4px",
    backgroundColor: "#C10E14",
  },
}));

const AboutImage = styled("img")(({ theme }) => ({
  width: "100%",
  borderRadius: "15px",
  boxShadow: "0 15px 35px rgba(0, 0, 0, 0.2)",
}));
const WhatWeAre = () => {
  return (
    <PageSection sx={{ bgcolor: "#fff" }}>
      <Container>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <SectionTitle variant="h4" component="h2" sx={{ mb: 3 }}>
                Who We Are
              </SectionTitle>
              <Typography
                variant="body1"
                paragraph
                sx={{ fontSize: "16px", lineHeight: 1.7 }}
              >
                Created with a vision of redefining real estate services in the
                UAE, DESCO is built on the foundation of trust, transparency and
                long-term relationships. Our team consists of some of the finest
                real estate professionals in Dubai, each handpicked for their
                market expertise, integrity and client-first approach.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{ fontSize: "16px", lineHeight: 1.7 }}
              >
                We serve investors, homeowners, tenants and developers – both
                locally and internationally – who rely on us for dependable
                advice and unmatched service.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{ fontSize: "16px", lineHeight: 1.7 }}
              >
                Over the years, we have helped thousands of clients buy, sell,
                rent and lease properties across Dubai, from the city's iconic
                apartments in Downtown Dubai and Dubai Marina to waterfront
                villas in Palm Jebel Ali and future-ready communities throughout
                the emirate.
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <AboutImage src={aboutusImage} alt="DESCO About" />
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </PageSection>
  );
};

export default WhatWeAre;
